import requests from './httpService';

const EnquiryService = {
  submitPublicEnquiry(schooleId, body) {
    return requests.post(`/enquiry/public/${schooleId}`, body);
  },

  listEnquiriesForSchool(schooleId) {
    return requests.get(`/enquiry/admin/${schooleId}`);
  },

  deleteEnquiry(schooleId, enquiryId) {
    return requests.delete(`/enquiry/admin/${schooleId}/${enquiryId}`);
  },
};

export default EnquiryService;

